// extracted by mini-css-extract-plugin
export default {"container":"Notification__container___zHfaz","notifyContainer":"Notification__notifyContainer___SNDDC"};